import { capitalize } from "@mui/material";

// Keywords that should always be capitalized
const CAPITALIZED_KEYWORDS: Record<string, string> = {
  ai: "AI",
  api: "API",
  css: "CSS",
  html: "HTML",
  http: "HTTP",
  https: "HTTPS",
  id: "ID",
  js: "JS",
  json: "JSON",
  jwt: "JWT",
  sql: "SQL",
  ui: "UI",
  url: "URL",
  uri: "URI",
  uuid: "UUID",
  xml: "XML",
  xpath: "XPath",
  dom: "DOM",
  pdf: "PDF",
  csv: "CSV",
  smtp: "SMTP",
  ftp: "FTP",
  ssh: "SSH",
  tcp: "TCP",
  udp: "UDP",
  ip: "IP",
  oauth: "OAuth",
  sso: "SSO",
  cdn: "CDN",
  aws: "AWS",
  gcp: "GCP",
  dns: "DNS",
  ssl: "SSL",
  tls: "TLS",
  rpc: "RPC",
  rest: "REST",
  sdk: "SDK",
  cli: "CLI",
  gui: "GUI",
  mvc: "MVC",
  oop: "OOP",
  pw: "PW",
};

export const humanizeText = (text: string): string => {
  // Replace underscores with spaces and split into words
  const words = text.replace(/_/g, " ").toLowerCase().split(" ");

  // Process each word
  const processedWords = words.map((word) => {
    // Check if the word is in our special keywords list
    if (CAPITALIZED_KEYWORDS[word]) {
      return CAPITALIZED_KEYWORDS[word];
    }
    // Otherwise, just capitalize the first letter
    return capitalize(word);
  });

  return processedWords.join(" ");
};

export const markdownToPlainText = (markdown: string): string => {
  // Simple regex to remove markdown syntax
  return markdown
    .replace(/!\[.*?\]\(.*?\)/g, "") // Remove images
    .replace(/\[([^\]]+)\]\((.*?)\)/g, "$1") // Remove links but keep text
    .replace(/[#>*_`~-]/g, "") // Remove markdown symbols
    .replace(/\n+/g, " ") // Replace new lines with space
    .trim();
};
